import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sign-up")({
  beforeLoad: async ({ context }) => {
    // No public sign-up on org subdomains (membership is invite-only there).
    if (context.subdomain) {
      throw redirect({ to: "/sign-in" });
    }
    if (context.userId) {
      throw redirect({ to: "/app" });
    }
  },
  component: SignUpLayout,
});

function SignUpLayout() {
  return <Outlet />;
}
